export const SET_ERROR = 'ERROR/SET_ERROR';
export const CLEAR_ERROR = 'ERROR/CLEAR_ERROR';
export const setError = (payload) => ({
    type: SET_ERROR,
    payload
});
export const clearError = () => ({
    type: CLEAR_ERROR,
    payload: null
});
